<template>
  <div class="content-kpi">
    <div class="mb-3">
      <b-card>
        <div class="identity-employee">
          <h5>{{ singlePickEmployee.name }}</h5>
          <div class="detail mt-1">
            <div class="content">
              <div class="text-muted p-3 mr-1 ml-1">
                <div class="detail-info row justify-content-between d-flex">
                  <div class="info col">
                    Position
                  </div>
                  <div class="info col text-right font-weight-bold">
                    {{ singlePickEmployee.position }}
                  </div>
                </div>
                <div class="detail-info row justify-content-between d-flex">
                  <div class="info col">
                    Role
                  </div>
                  <div class="info col text-right font-weight-bold">
                    {{ singlePickEmployee.role }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div>
      <b-card>
        <h6 class="mb-4 font-weight-bold">Filter</h6>
        <b-row>
          <b-col>
            <b-form-group
              label="Month(s)"
            >
              <custom-select
                label="name"
                v-model="filterMonth"
                :options="monthFilter.filters"
                placeholder="Select month"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Year(s)">
              <custom-select
                label="year"
                v-model="filterYear"
                :options="yearOptions"
                placeholder="Select year"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="button-project mt-5 d-flex justify-content-end">
          <b-button
            class="reset mr-3"
            variant="outline-warning"
            @click="resetFilter"
          >
            Reset Filter
          </b-button>
          <b-button
            class="next"
            variant="warning"
            @click="applyFilter"
          >
            Apply Filter
          </b-button>
        </div>
      </b-card>
    </div>
    <b-card class="table-list my-4">
      <h5 class="mb-4 mt-2 font-weight-bold">Employee Key Performance Indicator</h5>
      <div class="mb-3">
        <b-button variant="warning" class="text-white" @click="openModalCreateKpi">
          Create Assesment KPI
        </b-button>
      </div>
      <b-table
        ref="table"
        striped
        v-show="listKpi.length"
        :items="fetchList"
        :fields="fields"
        responsive
        @change="$refs.table.refresh()"
      >
        <template #cell(no)="{ index }">
          <div>
            {{ index + 1 }}
          </div>
        </template>
        <template #cell(actions)="data">
          <div class="data">
            <b-link
              class="text-secondary mx-2"
              v-if="data.item.scoreKPI === 0"
            >
              <fa-icon icon="file-alt" @click="openModalAssessment(data.item)"/>
            </b-link>
            <b-link
              class="text-secondary mx-2"
              v-if="data.item.scoreKPI !== 0"
            >
              <fa-icon icon="edit" @click="openModalUpdate(data.item.kpiId)"/>
            </b-link>
            <b-link
              class="text-secondary mx-2"
              v-if="data.item.scoreKPI !== 0"
            >
              <fa-icon icon="eye" @click="openModalViewKpi(data.item.kpiId)"/>
            </b-link>
            <b-link
                class="text-secondary mx-2"
              >
              <fa-icon icon="trash" @click="openModalDeleteKpi(data.item.id)"/>
            </b-link>
          </div>
        </template>
      </b-table>
      <assessment-key-performance-indicator
        :employee="singlePickEmployee"
        :objectives="kpiObjectives"
        :objectivePerEmployee="objectiveByIdEmployee"
        @result-request="recieveData"
        @refresh-table="$refs.table.refresh()"
      />
      <div class="d-flex justify-content-between">
        <div>
          <span>Show</span>
          <b-form-select
            v-model="perPage"
            :options="pageOptions"
            @change="$refs.table.refresh()"
            class="page-option ml-2 mr-2 w-auto"
            size="sm"
          />
          <span>Entries</span>
        </div>
        <div>
          <b-pagination
            class="mb-0"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            pills
            hide-goto-end-buttons
            @input="$refs.table.refresh()"
          />
          <span class="show-entries mr-auto">
            {{`Show ${totalRows === 0 ? 0 : ((currentPage-1) * perPage) + 1} to ${totalRows > ((currentPage) * perPage) ? ((currentPage) * perPage) : totalRows} of ${totalRows} entries`}}
          </span >
        </div>
      </div>
    </b-card>
    <modal-delete-kpi @remove="deleteKPI"/>
    <modal-view-kpi :kpi="listKpiDetail" :objective="kpiObjectives"/>
    <modal-update-kpi
      :kpi="listKpiDetail"
      :objective="kpiObjectives"
      @result-request="recieveData"
      @refresh-table="$refs.table.refresh()"
    />
    <modal-create-kpi @create="createKpi"/>
  </div>
</template>

<script>
import AssessmentKeyPerformanceIndicator from './AssessmentFormKPI'
import ModalDeleteKpi from './ModalDeleteKpi'
import ModalViewKpi from './ModalViewAssessment'
import ModalUpdateKpi from './ModalUpdateKPI'
import ModalCreateKpi from './ModalCreateKpi'
import api from '@/api'

export default {
  components: {
    AssessmentKeyPerformanceIndicator,
    ModalDeleteKpi,
    ModalViewKpi,
    ModalUpdateKpi,
    ModalCreateKpi
  },
  data() {
    return {
      listKpi: [],
      listKpiDetail: [],
      singlePickEmployee: {
        id: '',
        name: '',
        employeeNo: '',
        position: '',
        role: '',
        kpiId: ''
      },
      formDelete: {
        id: '',
        name: ''
      },
      kpiObjectives: [],
      objectivePerEmployee: [],
      fields: [
        { key: 'no', label: 'No', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'scoreKPI', label: 'KPI Score', tdClass: 'text-center', thClass: 'text-center' },
        { key: 'month', label: 'Month', tdClass: 'text-center', thClass: 'text-center' },
        { key: 'year', label: 'Year', tdClass: 'text-center', thClass: 'text-center' },
        { key: 'actions', label: 'Actions', tdClass: 'text-center', thClass: 'text-center' }
      ],
      filters: 'Status==true',
      filterMonth: [],
      monthFilter: {
        show: true,
        filters: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'Desember'
        ]
      },
      filterYear: new Date().getFullYear(),
      yearOptions: [
        2023
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      totalPage: 0,
      pageOptions: [10, 20, 50, 100],
      objectiveByIdEmployee: {
        employeeId: '',
        kpiId: '',
        year: 0,
        month: 0,
        summary: 0,
        objective: []
      }
    }
  },
  methods: {
    async fetchList() {
      let filters = `employeeId==${this.$route.params.id}`
      if (this.filterMonth.length !== 0) {
        filters += `, month==${this.filterMonth}`
      }
      if (this.filterYear.length !== 0) {
        filters += `, year==${this.filterYear}`
      }
      try {
        const { data } = await api.kpi.list({
          page: this.currentPage,
          pageSize: this.perPage,
          Filters: filters,
          sorts: 'fullName'
        })
        this.listKpi = data.data.length !== 0 ? data.data : []
        this.totalRows = data.length !== 0 ? data.totalData : 0
        this.totalPage = data.totalPage
        this.listKpi = data.data.map((employee, i) => {
          return {
            id: employee.id,
            employeeId: employee.employeeId,
            kpiId: employee.id,
            scoreKPI: employee.summary,
            month: employee.month,
            year: employee.year,
            _rowVariant: i % 2 === 0 ? 'warning' : null
          }
        })
      } catch (error) {
        console.log(error)
      }
      return this.listKpi
    },
    async getEmployeeByFilter(id) {
      try {
        const { data } = await api.employee.list({
          page: 1,
          pageSize: 1,
          Filters: `id==${id}`
        })
        this.singlePickEmployee = {
          id: data.data[0].id,
          name: data.data[0].fullName,
          position: data.data[0].position,
          role: data.data[0].role,
          employeeNo: data.data[0].employeeNo
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getDetailByKpiId(id) {
      try {
        const { data } = await api.kpi.getKpiDetail({
          page: 1,
          pageSize: 50,
          Filters: `kpiId==${id}`
        })
        this.listKpiDetail = []
        this.listKpiDetail = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async getObjectiveKpi() {
      try {
        const { data } = await api.kpi.getObjectiveKpi()
        this.kpiObjectives = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async getObjectiveEmployee() {
      try {
        const { data } = await api.kpi.getObjectiveEmployee()
        this.objectivePerEmployee = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async createKpi(data) {
      try {
        await api.kpi.createKpi({
          employeeId: this.$route.params.id,
          month: data.month,
          year: data.year
        })
        this.$nextTick(() => {
          this.$bvToast.toast('Success Craete KPI', {
            headerClass: 'd-none',
            solid: true,
            variant: 'success'
          })
          this.$refs.table.refresh()
        })
      } catch (error) {
        console.log(error)
        this.$nextTick(() => {
          this.$bvToast.toast('Failed create KPI', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
          this.$refs.table.refresh()
        })
      }
    },
    async deleteKPI() {
      let result = false
      try {
        await api.kpi.deleteKpi(this.targetDeleteIdKpi)
        this.$nextTick(() => {
          this.$bvToast.toast('Success delete KPI', {
            headerClass: 'd-none',
            solid: true,
            variant: 'success'
          })
          this.$refs.table.refresh()
        })
        result = true
      } catch (error) {
        console.log(error)
        this.$nextTick(() => {
          this.$bvToast.toast('Failed delete KPI', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
          this.$refs.table.refresh()
        })
      }
      if (result) {
        this.deleteKpiDetail(this.targetDeleteIdKpi)
      }
    },
    async deleteKpiDetail(id) {
      const listDeleteKpiDetail = []
      this.getDetailByKpiId(id)
      this.listKpiDetail.forEach(item => {
        if (item.kpiId === id) {
          listDeleteKpiDetail.push(item.id)
        }
      })
      try {
        await Promise.all(listDeleteKpiDetail.map(async item => {
          await api.kpi.deleteDetail(item)
        }))
        this.listKpiDetail = []
      } catch (error) {
        console.log(error)
      }
    },
    filterObjectiveByIdEmployee(data) {
      this.objectiveByIdEmployee = {
        employeeId: '',
        kpiId: '',
        year: 0,
        month: 0,
        objective: []
      }
      this.objectivePerEmployee.forEach(item => {
        if (item.employeeId === data.employeeId) {
          this.objectiveByIdEmployee.employeeId = data.employeeId
          this.objectiveByIdEmployee.kpiId = data.kpiId
          this.objectiveByIdEmployee.year = data.year
          this.objectiveByIdEmployee.month = data.month
          this.objectiveByIdEmployee.summary = data.scoreKPI
          this.kpiObjectives.forEach(kpi => {
            if (kpi.id === item.objectiveId) {
              this.objectiveByIdEmployee.objective.push({
                objectiveId: item.objectiveId,
                name: kpi.name
              })
            }
          })
        }
      })
    },
    converNameMonthToNumber(monthName) {
      const month = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        Desember: 12
      }
      return month[monthName]
    },
    openModalAssessment(item) {
      this.modalTitle = 'Assessment Key Performance Indicator'
      this.filterObjectiveByIdEmployee(item)
      this.$bvModal.show('modal-assessment-kpi')
    },
    openModalCreateKpi() {
      this.$bvModal.show('modal-create-kpi')
    },
    openModalDeleteKpi(id) {
      this.targetDeleteIdKpi = id
      this.$bvModal.show('modal-delete-kpi')
    },
    openModalViewKpi(id) {
      this.getDetailByKpiId(id)
      this.$bvModal.show('modal-view-kpi')
    },
    openModalUpdate(id) {
      this.getDetailByKpiId(id)
      this.$bvModal.show('modal-update-kpi')
    },
    recieveData(data) {
      this.$nextTick(() => {
        this.$bvToast.toast(data.message, {
          headerClass: 'd-none',
          solid: true,
          variant: data.variant
        })
        this.$refs.table.refresh()
      })
    },
    applyFilter() {
      this.$refs.table.refresh()
    },
    resetFilter() {
      this.filterMonth = []
      this.filterYear = new Date().getFullYear()
      this.$refs.table.refresh()
    }
  },
  created() {
    for (this.filterYear; this.yearOptions[0] < this.filterYear; this.filterYear--) {
      this.yearOptions.push(this.filterYear)
    }
    this.getEmployeeByFilter(this.$route.params.id)
    this.getObjectiveKpi()
    this.getObjectiveEmployee()
  }
}
</script>

<style lang="scss" scoped>
.content-kpi {
  margin-top: 20px;
  padding: 2px;
}

.table-list{
  background-color: white;
}
</style>
